import _ from 'lodash';

const ABSOLUTE_ELEMENTS = [
    '.link-components-select__menu',
    '.link-components-select',
    '.link-components-view',
    '.ant-select-open',
];

const MINIMUM_HEIGHT = 65;

const Iframe = {
    _getAbsoluteElementsMaxBottom() {
        const bottoms = ABSOLUTE_ELEMENTS.map((selector) => {
            const elements = document.querySelectorAll(selector);

            return Array.prototype.map.call(elements, (element) => {
                if (element) {
                    const computedStyle = window.getComputedStyle(element);
                    if (computedStyle && computedStyle.display !== 'none') {
                        const rect = element.getBoundingClientRect();
                        if (selector === '.link-components-view') {
                            return 30;
                        }
                        if (selector === '.link-components-select') {
                            return 30;
                        }
                        if (selector === '.link-components-select__menu') {
                            return 380;
                        }
                        if (selector === '.ant-select-open') {
                            return 380;
                        }
                        return rect.bottom;
                    }
                }
                return 0;
            });
        });

        const flattenedBottoms = _.flatten(bottoms);

        return Math.max(...flattenedBottoms);
    },

    _computeRequiredHeight() {
        const staticHeight = Iframe._getStaticHeight();
        const absoluteElementsBottom = Iframe._getAbsoluteElementsMaxBottom() + 15;

        return Math.max(staticHeight, absoluteElementsBottom);
    },

    _getStaticHeight(app = null) {
        const appElement = app || document.getElementById('root');
        const appHeight = appElement.getBoundingClientRect().height;

        if (appHeight < MINIMUM_HEIGHT) {
            return MINIMUM_HEIGHT;
        }
        return appHeight;
    },

    adjustFrameHeight() {
        setTimeout(() => {
            const componentElement = document.getElementById('link-component-wrapper');
            if (componentElement) {
                const appHeight = componentElement.scrollHeight + 30;
                window.PlatformAdapter.resizeWindow('100%', `${appHeight}px`);
            }
        }, 0);
    },

    adjustFrameHeightVersions() {
        setTimeout(() => {
            const componentElement = document.getElementById('link-component-version-wrapper');
            if (componentElement) {
                const appHeight = componentElement.scrollHeight + 30;
                window.PlatformAdapter.resizeWindow('100%', `${appHeight}px`);
            }
        }, 0);
    },

    getWidth() {
        const appElement = document.getElementById('root');
        return appElement.getBoundingClientRect().width;
    },
};

export default Iframe;
